import { BeRow, BeStack, BeText } from "@beos-css/react/index.ts";

export function SurfaceDemo() {
	return (
		<section id="demo-surface">
			<h2>Surface (.be-panel)</h2>
			<p>
				The raised or sunken bevel that panels, cards and wells are all drawn from. Press and hold the row at the bottom: the panel inverts,
				and both of its text runs turn white.
			</p>
			<BeRow wrap gap="row">
				<BeStack className="be-panel" pad="group">
					raised
				</BeStack>
				<BeStack className="be-panel is-sunken" pad="group">
					sunken
				</BeStack>
				<BeStack className="be-panel is-sunken is-field" pad="group">
					field
				</BeStack>
				<BeStack className="be-panel is-flat" pad="group">
					flat
				</BeStack>
				<BeStack className="be-panel" pad="group" aria-current="true">
					current
				</BeStack>
			</BeRow>
			{/* two faces in one pressed region, so each has to name its own light ramp */}
			<BeStack className="be-panel" pad="item">
				<button type="button" className="be-action-area">
					<BeRow align="center">
						<BeText face="mini" ink="secondary">
							1. Drop shadow
						</BeText>
						<BeText as="code">0px 2px 4px 0px rgb(0, 0, 0)</BeText>
					</BeRow>
				</button>
			</BeStack>
		</section>
	);
}
